"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateFilterIgnoredForInsight = exports.addImplicitAllTimeFilter = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var internal_1 = require("../../../internal");
function addImplicitAllTimeFilter(widget, resolvedFilters) {
    // if the widget is connected to a dateDataset and has no date filters for it in the context,
    // add an implicit All time filter for that dimension - this will cause the InsightView to ignore
    // any date filters on that dimension - this is how KPI dashboards behave
    if (widget.dateDataSet && !internal_1.hasDateFilterForDateDataset(resolvedFilters, widget.dateDataSet)) {
        return tslib_1.__spreadArrays(resolvedFilters, [sdk_model_1.newAllTimeFilter(widget.dateDataSet)]);
    }
    return resolvedFilters;
}
exports.addImplicitAllTimeFilter = addImplicitAllTimeFilter;
/**
 * Tests whether dashboard's date filter should not be applied on the insight included in the provided widget.
 *
 * This should happen for insights whose simple measures are all already set up with date filters. I guess ignoring
 * global date filter is desired because otherwise there is a large chance that the intersection of global date filter
 * and measure's date filters would lead to empty set and no data shown for the insight?
 */
function isDateFilterIgnoredForInsight(insight) {
    var simpleMeasures = sdk_model_1.insightMeasures(insight, sdk_model_1.isSimpleMeasure);
    if (simpleMeasures.length === 0) {
        return false;
    }
    var simpleMeasuresWithDateFilter = simpleMeasures.filter(function (m) { var _a; return ((_a = sdk_model_1.measureFilters(m)) !== null && _a !== void 0 ? _a : []).some(sdk_model_1.isDateFilter); });
    return simpleMeasures.length === simpleMeasuresWithDateFilter.length;
}
exports.isDateFilterIgnoredForInsight = isDateFilterIgnoredForInsight;
//# sourceMappingURL=utils.js.map